import React, { CSSProperties, useEffect, useState } from 'react';
import * as web3 from "@solana/web3.js"
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { Provider } from '../models/Provider';
import { ProviderAdRelation } from '../models/ProviderAdRelation';
import Ad from "../components/Ad";
import { useProgram } from "../utils/ProgramContext";
import { Link } from 'react-router-dom';

const styles: { [key: string]: CSSProperties } = {
    list: {
        padding: 0,
        listStyleType: 'none',
    },
    listItem: {
        margin: '10px 0',
        padding: '15px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
    },
    name: {
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    checkbox: {
        marginRight: '10px',
    },
};

const ManagePendingAds: React.FC = () => {
    const [providers, setProviders] = useState<Provider[]>([])
    const [providerAdRelations, setProviderAdRelations] = useState<{ [key: string]: ProviderAdRelation[] }>({})
    const { connection } = useConnection()
    const { publicKey, sendTransaction } = useWallet();
    const { program } = useProgram() || {}

    useEffect(() => {
        async function getAccounts() {
            if (!program || !publicKey) {
                return
            }

            const accountsPromises = [];
            for (const index of [1]) { // Assume this will change based on ProviderCount in User
                const [providerPda] = Provider.findAddress(publicKey, index);
                // Store both the promise and its associated providerPda
                const promiseWithPda = program.account.provider.fetch(providerPda).then(account => {
                    return { account, providerPda }; // Return an object with both the account data and the providerPda
                });
                accountsPromises.push(promiseWithPda);
            }

            // Now, when you resolve the promises, each resolved value will include both the account and its providerPda
            const results = await Promise.all(accountsPromises);

            if (results.length == 0) {
                return;
            }

            const res = [];
            for (const { account, providerPda } of results) {
                if (account) {
                    // Now you can pass providerPda as an argument to the constructor
                    res.push(new Provider(account.id as number, account.name as string, account.location as string, providerPda));
                }
            }
            setProviders(res)
        }
        getAccounts()
    }, [publicKey])

    useEffect(() => {
        const fetchRelations = async () => {
            let adRelations = {}
            for (const provider of providers) {
                if (provider.publicKey) {
                    const res = await program?.account.providerAdCampaignRelation.all([{
                        memcmp: {
                            offset: 8,
                            bytes: provider.publicKey.toBase58()
                        }
                    }
                    ])
                    if (!res || !provider) {
                        return
                    }
                    adRelations = {
                        ...adRelations,
                        [provider.publicKey.toString()]:
                            res.map(
                                relation => new ProviderAdRelation(
                                    provider.publicKey as web3.PublicKey,
                                    relation.account.adCampaign as web3.PublicKey,
                                    relation.account.state as number
                                )
                            )
                    }

                }
            }

            setProviderAdRelations(adRelations)
        }
        fetchRelations();
    }, [providers])

    const handleAccept = (event: any, provider: Provider, ad_pubkey: web3.PublicKey) => {
        event.preventDefault();
        handleTransactionSubmit(provider, ad_pubkey)
    }

    const handleTransactionSubmit = async (provider: Provider, ad_pubkey: web3.PublicKey) => {
        if (!publicKey || !program) {
            alert("Please connect your wallet!");
            return;
        }

        const [provider_pda] = Provider.findAddress(publicKey, 1)
        console.log("THIS IS TEMPORARY CHAGNE THE 1 TO USER provider_index")
        console.log(provider_pda)
        const [relation] = ProviderAdRelation.findAddress(provider.publicKey as web3.PublicKey, ad_pubkey)

        const transaction = await program.methods.approveAdCampaign(
            provider.id
        ).accounts({
            providerAdCampaignRelation: relation,
            provider: provider_pda,
            authority: publicKey,
        }).transaction()

        try {
            const txid = await sendTransaction(transaction, connection);
            alert(
                `Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
            );
            console.log(
                `Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
            );
        } catch (e) {
            console.log(JSON.stringify(e));
            alert(JSON.stringify(e));
        }

    }

    return (
        <main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6">
            <div className="flex items-center">
                <h1 className="text-lg font-semibold md:text-2xl">Manage Pending Ads</h1>
            </div>
            <div className="flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm">
                <div className="flex flex-col items-center gap-1 text-center">
                    {!publicKey ?
                        <div>Please Connect Wallet</div> :
                        <div className="screen-provider-list">
                            <ul style={styles.list}>
                                {providers.map((provider, index) => (
                                    <li key={index} style={styles.listItem}>
                                        <div style={styles.name}>Name: {provider.name}</div>
                                        <div style={styles.name}>Location: <a href={provider.location} target="_blank" rel="noreferrer">{provider.location}</a></div>
                                        <div style={styles.name}>PublicKey: {provider.publicKey?.toString()}</div>
                                        <ul style={styles.list}>
                                            {
                                                provider.publicKey && provider.publicKey.toString() in providerAdRelations &&
                                                providerAdRelations[provider.publicKey.toString()]
                                                    .map((relation: ProviderAdRelation, ad_indx: React.Key) => {

                                                        let state = ""
                                                        if (relation.state == 0) {
                                                            state = "PENDING"
                                                        } else if (relation.state == 1) {
                                                            state = "APPROVED"
                                                        } else if (relation.state == 2) {
                                                            state = "DENIED"
                                                        } else {
                                                            state = "UNKNOWN"
                                                        }

                                                        return <li key={ad_indx} style={styles.listItem}>
                                                            <Ad publicKey={relation.ad} />
                                                            <div style={styles.name}>Status: {state}</div>
                                                            <button className={"m-5 bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"} disabled={state != "PENDING"} onClick={(event) => handleAccept(event, provider, relation.ad)}>Run Ad</button>
                                                        </li>
                                                    })
                                            }
                                        </ul>
                                        <Link className={"m-5 bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"} to={`/app/manage-publisher/${provider.id}`}>ManageAuction</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }
                </div>

            </div>
        </main>
    );
};

export default ManagePendingAds;
